<template>
  <b-col class="d-flex toast-container" :class="[extraClass]">
    <div class="text-wrap">
      <div class="color-noble-blue-500 font-weight-700 mb-1">
        <b-icon-exclamation-circle class="icon-alert" />
        <span class="drip-h4 ml-2 account-title">
          {{ $t('account.index.accountDataRequired') }}</span
        >
      </div>
      <div
        class="account-sub drip-body color-noble-blue-500 mb-24-add font-weight-normal"
      >
        {{
          $t('account.index.accountDataRequiredSubtitle', {
            blockDate: date
          })
        }}
      </div>
    </div>
    <action-button
      variant="solid"
      :click="goToAccountDetails"
      :extraClass="'add btn-alert'"
    >
      {{ $t('account.index.updateNow') }}
      <b-icon-chevron-right class="breadcrumb-section" />
    </action-button>
  </b-col>
</template>

<script>
import ActionButton from '@/components/common/ActionButton.vue'

export default {
  props: {
    extraClass: {
      type: String,
      default: ''
    },
    date: {
      type: String
    },
    newTab: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goToAccountDetails() {
      if (!this.newTab) {
        this.$mpTrack('Account Details - "Update now" button clicked')
        this.$router.push({ name: 'account' })
      } else {
        this.$mpTrack('Account Details - "Update now" button clicked')
        const routeUrl = this.$router.resolve({ name: 'account' }).href
        window.open(routeUrl, '_blank') // Opens the route in a new tab
      }
    }
  },
  components: {
    ActionButton
  }
}
</script>

<style lang="scss" scoped>
.breadcrumb-section {
  font-weight: 700;
  font-size: 12px !important;
  margin-left: 8px;
}
.icon-alert {
  color: $orange-500;
  font-size: 20px;
}
.toast-container {
  display: flex;
  padding: 16px 24px;
  border: 1px solid $orange-400;
  border-left: 8px solid $orange-400;
  border-radius: 8px;
  background: $white;
  margin-bottom: 9px;
  justify-content: space-between;
}
</style>
